import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import packageConfig from '../../package.json';

const { version } = packageConfig;

const initI18n = ({ lng = 'ru', hostname = null }) => {
  let loadPath = `${process.env.PUBLIC_PATH || './dist'}/locales/{{lng}}/{{ns}}.json?v=${version}`;

  if (process.env.NODE_ENV === 'development') {
    loadPath = `http://localhost:1234/dist/locales/{{lng}}/{{ns}}.json?v=${version}`;
  }

  if (hostname) {
    loadPath = `${hostname.replace(
      '//',
      '//jswidget.',
    )}/latest/locales/{{lng}}/{{ns}}.json?v=${version}`;
  }

  return i18next
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng,
      fallbackLng: lng,
      debug: false,
      ns: ['common'],
      defaultNS: 'common',
      backend: {
        loadPath: loadPath,
      },
      react: {
        wait: false,
        useSuspense: false,
      },
    });
};

export default initI18n;
